import { requireAuth } from '@/features/auth/guards/require-auth'
import { StockPage } from '@/features/stock/pages/stock-page'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const searchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  page_size: z.coerce
    .number()
    .int()
    .refine((n) => [50, 100, 200].includes(n))
    .catch(50),
  warehouse_ids: z.array(z.coerce.number()).catch([]),
  item_types: z.array(z.enum(['material', 'remnant', 'part', 'assembly'])).catch([]),
  search: z.string().catch(''),
  sort_by: z.enum(['warehouse', 'code', 'name', 'quantity', 'size']).catch('warehouse'),
  sort_dir: z.enum(['asc', 'desc']).catch('asc'),
})

export const Route = createFileRoute('/_app/stock')({
  validateSearch: searchSchema,
  beforeLoad: requireAuth,
  staticData: { crumb: messages.stock.title },
  component: StockRoute,
})

function StockRoute() {
  return <StockPage />
}
